import React, { useEffect, useState, useRef, Fragment } from 'react'
import {
  PlusCircleOutlined
} from '@ant-design/icons'
import {
  Button,
  Row,
  Col,
  Input,
  Select,
  Tooltip,
  Form,
  Popover,
  Space,
  Tabs,
  Alert, message,
  Radio,
  Modal,
  Table
} from 'antd'
import '../detail.less'
import _, { get, set } from 'lodash'
import '@ant-design/pro-table/dist/table.css'
import { fetchInvoices } from '../api'
import { mutipleNote } from '../config'
import Decimal from 'decimal.js';

import { getSid,} from '@/public/utils'

const FormItem = Form.Item

const mutileEnterModal = (props) => {
  const length = props.type == '01' ? 8 : 20
  const [open] = useState(true)
  const [data, setData] = useState([
    { from: '', to: '', index: 0, id: 0 }
  ])
  const [listdatas, setlistdatas] = useState([])
  const columns = [
    {
      title: length + '位起始发票号码',
      key: 'from',
      dataIndex: 'from',
      width: 130,
      fixed: 'left',
      align: 'center',
      render: (text, record) => {
        return (
          <div style={{height: '50px'}}>
            <Input
              style={{ width: 200, borderColor: record['fromerror'] ? 'red' : ''}}
              placeholder="请输入"
              value={get(record, 'from')}
              name='from'
              maxLength={length}
              onChange={iptChange.bind(this, record)}
              onBlur={lengchange.bind(this, record, 'from')}
            />
            { record['fromlenerror'] ? <div style={{color: 'red', marginTop: '4px', fontSize: '13px', position: 'relative', left: '-18px'}}>请输入{length}位发票号码</div> : null}
          </div>
        )
      }
    },
    {
      title: '',
      key: 'index',
      dataIndex: 'index',
      width: 130,
      fixed: 'left',
      align: 'center',
      render: (text) => {
        return (<span>至</span>)
      }
    },
    {
      title: length + '位结束发票号码',
      key: 'to',
      dataIndex: 'to',
      width: 130,
      fixed: 'left',
      align: 'center',
      render: (text, record,index) => {
        return (
          <div style={{height: '50px'}}>
            <Input
              style={{ width:200, borderColor: record['toerror'] ? 'red' : ''}}
              placeholder="请输入"
              value={get(record, 'to')}
              name='to'
              min={get(record,'from') + 1}
              maxLength={length}
              onChange={iptChange.bind(this, record)}
              onBlur={lengchange.bind(this, record, 'to',index)}
              onFocus={toFocus.bind(this,record,index)}
            />
            {record['tolenerror'] ? <div style={{color: 'red', marginTop: '4px', fontSize: '13px', position: 'relative', left: '-18px'}}>请输入{length}位发票号码</div> : null}
            {record['tomaxerror'] ? <div style={{color: 'red', marginTop: '4px', fontSize: '13px', position: 'relative', left: '-18px'}}>结束发票号码要大于起始发票号码</div> : null}
          </div>
        )
      }
    },
    {
      title: '操作',
      key: 'id',
      dataIndex: 'id',
      width: 130,
      fixed: 'left',
      align: 'center',
      render: (text) => {
        return text != '0' && <a onClick={() => { setData(_.differenceBy(data, [{ id: text }], 'id')) }}>删除</a>
      }
    }
  ]

  const iptChange = (record, e) => {
    var key = e.target.name
    var value = e.target.value.trim()
    var newData = _.cloneDeep(data)
    var val = /^[0-9]\d*$/.test(value) ? value : get(record, key)
    newData.forEach(item => {
      set(item, key, get(item, 'index') == get(record, 'index') ? (value ? val : '') : get(item, key))
    })
    setData(newData)
  }
  const lengchange = (record, type) => {
    var newData = _.cloneDeep(data)
    setData(newData.map(a => {
      var lenerror = record[type].length != length
      var maxerror = parseInt(get(record,'to'))<parseInt(get(record,'from'))
      return {
        ...a,
        [type + 'lenerror']: !maxerror&&lenerror,
        [type + 'maxerror']: !lenerror&&maxerror
      }
    }))
    if ((record.to && record.from) && (record.to.length == length && record.from.length == length)) {
      confirmEnter(true)
    }
  }

  const toFocus =(record,index)=>{
    var newData = _.cloneDeep(data)
    var start = new Decimal(get(record,'from')).plus(1)
    const endMin =("00000000000000000000"+(start)).substr( -length )
    setData(newData.map(a => {
      return {
        ...a,
        to:get(record,'index')==get(a,'index')?endMin:get(a,'to')
      }
    }))
  }

  const confirmEnter = async (types) => {
    var bypersonArr = _.keys(get(props.enums, '发票类型枚举值(系统)'))
    var query = {
      is_all: true,
      sid: getSid(),
      invoice_source: bypersonArr.includes(props.type) ? '00' : '02',
      invoice_type: props.type,
      invoice_no_scope_list: data.map(item => {
        return {
          ...item,
          'invoice_no_start': get(item, 'from'),
          'invoice_no_end': get(item, 'to')
        }
      })
    }
    try {
      let { data} = await (fetchInvoices({query}))
      var all_invoice_list = get(data, 'data.list')
      if(!get(all_invoice_list,'length')){
        message.error("未找到相关发票！")
        return
      }
      var efficient_list = _.filter(all_invoice_list,['is_occupy',false])
      if (!types) {
        props.setBill(efficient_list)
        props.setOpen(false)
        setlistdatas([])
      } else {
        setlistdatas(all_invoice_list)
      }
    } catch (err) {
      console.log(err)
    }
  }


  const addRow = () => {
    data.push({ from: '', to: '', index: 1 })
    var newData = data.map((item, index) => {
      return { ...item, index: index, id: index }
    })
    setData(newData)
  }

  return (
    <Modal
      title={<span>输入连续多张发票<span style={{marginLeft: '8px', color: 'grey', fontWeight: 400, fontSize: 14}}>{get(props.enums, '发票类型枚举值(系统)')[props.type]}</span></span>}
      visible={open}
      onOk={()=>confirmEnter()}
      width={800}
      onCancel={() => { props.setOpen(false) }}>
      <div>
        <Alert
          message={<div>{mutipleNote[length]}</div>}
          type="warning"
          showIcon
        />

        <Table
          className='mt20'
          columns={columns}
          dataSource={data || []}
          pagination={false}
        ></Table>
        <p className='mt20'><a onClick={() => { addRow() }}><PlusCircleOutlined className='mr6' />增加</a></p>
  <p className='mt20'>共查验成功<span className='redFont ml4 mr4' style={{fontSize:'16px'}}>{listdatas.length||0}</span>张发票 {listdatas.filter(a=>a.is_occupy).length ? <span> ，其中有<span className='redFont ml4 mr4'>{listdatas.filter(a=>a.is_occupy).length}</span>张发票已被匹配占用，占用的发票号码为 {((listdatas.filter(a=>a.is_occupy)||[]).map(a=>a.invoice_no)||[]).join('、')||'--'}</span>:null}</p>
      </div>
    </Modal>
  )
}

export default mutileEnterModal



// WEBPACK FOOTER //
// ./src/pages/billVerification/match/detail/components/mutipleEnterModal.js